import { useCallback } from "react";
import { Button } from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";

interface DateRangePresetRowProps {
  label: string;
  active: boolean;
  presetKey: string;
  onSelect: (key: string) => void;
}

export function DateRangePresetRow({
  label,
  active,
  presetKey,
  onSelect,
}: DateRangePresetRowProps) {
  const handleClick = useCallback(() => {
    onSelect(presetKey);
  }, [onSelect, presetKey]);

  return (
    <Button
      onClick={handleClick}
      variant={active ? "light" : "subtle"}
      color={active ? "blue" : "gray"}
      size="xs"
      justify="space-between"
      fullWidth
      rightSection={
        active ? <IconCheck size={14} /> : <span style={{ width: 14 }} />
      }
      styles={{
        label: { fontWeight: active ? 600 : 400 },
        inner: { justifyContent: "space-between" },
      }}
    >
      {label}
    </Button>
  );
}
